var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.classes,
      on: {
        scroll: function(event) {
          return event.stopPropagation()
        }
      }
    },
    [
      _c(
        "div",
        {
          style: _vm.isOpen
            ? "width: " + _vm.width + ";" + "height: " + _vm.height
            : "width: 0%; height: " + _vm.height
        },
        [
          _c(
            "div",
            { staticClass: "overlay-header bg-white w-100 shadow-sm px-2" },
            [
              _c(
                "div",
                {
                  staticClass: "mr-md-5",
                  style: _vm.isMobile ? "width: 100%;" : ""
                },
                [_vm._t("header")],
                2
              ),
              _vm._v(" "),
              !_vm.hideClose
                ? _c(
                    "a",
                    {
                      class:
                        parseInt(_vm.width) > 90 ? "closebtn ext" : "closebtn",
                      attrs: { href: "javascript:void(0)" },
                      on: { click: _vm.close }
                    },
                    [_vm._v("×")]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "overlay-content" }, [_vm._t("default")], 2),
          _vm._v(" "),
          _vm.isOpen
            ? _c(
                "div",
                { staticClass: "overlay-footer" },
                [_vm._t("footer")],
                2
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b516c6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b516c6c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/modals/OverlayModal.vue
// module id = null
// module chunks = 